import type { ResultEntry } from '@schibsted-nmp/search-frontend-clients/quest';
import React from 'react';
import { useSearchData } from '../../data/SearchData';
import { useLocationUrl } from '../../state/LocationUrl';

const STORAGE_KEY = 'searchItems';

export function useSearchItems() {
    const { locationUrl } = useLocationUrl();
    const { searchData } = useSearchData();

    const storeSearchItems = React.useCallback(
        (ad: ResultEntry) => {
            const docs = searchData?.docs ?? [];
            const urls = docs.map((ad) => ad.canonical_url);

            locationUrl.hash = ad.id;

            const searchItems = {
                search: locationUrl.href,
                urls,
            };

            try {
                window.sessionStorage.setItem(
                    STORAGE_KEY,
                    JSON.stringify(searchItems),
                );
            } catch {
                // ignore session storage missing or incognito mode
            }
        },
        [locationUrl, searchData],
    );

    return { storeSearchItems };
}
